import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import * as actions from '@dashboard-widget/actions/dashboard-widget-config.actions';
import { DashboardWidgetConfig } from '@dashboard-widget/dashboard-widget.types';

export const dashboardWidgetConfigurationFeature = 'dashboardWidgetConfiguration';

export const adapter = createEntityAdapter<DashboardWidgetConfig>();

export interface State extends EntityState<DashboardWidgetConfig> { };

export const INITIAL_STATE: State = adapter.getInitialState();

const dashboardWidgetConfigReducer = createReducer(
  INITIAL_STATE,
  on(actions.getDashboardWidgetConfigurationComplete, (state, { widgetId, config }) => {
    let item: DashboardWidgetConfig = state.entities[widgetId];
    item = { ...item, ...{ id: widgetId, config: config } };
    return adapter.upsertOne(item, state);
  }),

);

export function reducer(state: State | undefined, action: Action) {
  return dashboardWidgetConfigReducer(state, action);
}

